/**
 * UP CEL — Lógica de taxa de armazenamento de OS.
 * Regra: após aparelho estar "pronto", cliente tem 3 dias grátis.
 * Depois: R$ 1,00 por dia adicional.
 */

export const STORAGE_GRACE_DAYS = 3;
export const STORAGE_FEE_PER_DAY = 1.0;

/**
 * Calcula situação de armazenamento a partir de storage_start (ISO string).
 * Retorna null se storage_start não existir.
 */
export function computeOverdue(so) {
  if (!so || !so.storage_start) return null;
  if (so.status !== "pronto") return null; // já entregue ou ainda em reparo

  const startMs = new Date(so.storage_start).getTime();
  if (isNaN(startMs)) return null;

  const diffMs = Date.now() - startMs;
  const daysStored = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const daysOverdue = Math.max(0, daysStored - STORAGE_GRACE_DAYS);
  const fee = +(daysOverdue * STORAGE_FEE_PER_DAY).toFixed(2);

  return {
    overdue: daysOverdue > 0,
    daysStored,
    daysOverdue,
    fee,
  };
}

/**
 * Retorna apenas as OS que já estão atrasadas na retirada.
 * Ordenadas por dias vencidos (mais atrasadas primeiro).
 */
export function filterOverdue(orders = []) {
  return orders
    .map((so) => ({ so, info: computeOverdue(so) }))
    .filter((x) => x.info && x.info.overdue)
    .sort((a, b) => b.info.daysOverdue - a.info.daysOverdue);
}

/**
 * Monta mensagem de cobrança para WhatsApp.
 */
export function buildStorageChargeMsg(so, info) {
  const brl = (v) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(v || 0);

  const totalPagar = (so.price || 0) + info.fee;
  const brand = so.brand || "";
  const dev = so.device || "";
  const trackUrl =
    typeof window !== "undefined"
      ? `${window.location.origin}/track/${so.id || ""}`
      : "";

  return [
    `*UP CEL Quilombo — Aviso de retirada 📦*`,
    "",
    `Olá ${so.customer_name || "cliente"}! Tudo bem?`,
    "",
    `Seu aparelho *${brand ? brand + " " : ""}${dev}* já está pronto há *${info.daysStored} dias* aqui na assistência.`,
    "",
    `Conforme combinado, após 3 dias é cobrada *taxa de R$ 1,00 por dia* de armazenamento.`,
    "",
    `📅 Dias em atraso: *${info.daysOverdue}*`,
    `💰 Taxa acumulada: *${brl(info.fee)}*`,
    so.price > 0 ? `🔧 Serviço: ${brl(so.price)}` : "",
    so.price > 0 ? `💵 *Total a pagar: ${brl(totalPagar)}*` : `💵 *Total a pagar: ${brl(info.fee)}*`,
    "",
    trackUrl ? `📲 Acompanhamento completo: ${trackUrl}` : "",
    "",
    `Passa aqui pra buscar? A cada dia a taxa aumenta.`,
    "",
    `Obrigado! 💙`,
    `— UP CEL Quilombo`,
  ]
    .filter(Boolean)
    .join("\n");
}
